import React from 'react';
import Layout from '../components/Layout';
import QuickActions from '../components/QuickActions';
import { Card } from '../components/ui/card';

const Analytics = () => {
  return (
    <Layout>
      <div className="max-w-7xl mx-auto fade-in">
        <div className="flex justify-between items-center mb-6">
          <h1 className="text-4xl font-bold">Analytics</h1>
          <QuickActions position="top" />
        </div>
        <Card className="glass-effect p-8">
          <p className="text-gray-600">
            Analytics features coming soon. This comprehensive caregiving platform 
            includes full analytics and reporting capabilities.
          </p>
        </Card>
        <div className="mt-8">
          <QuickActions position="bottom" />
        </div>
      </div>
    </Layout>
  );
};

export default Analytics;
